"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateStudyReportResponse = exports.GetStudyReportListDownloadUrlResponse = exports.DownloadStudyReportResponse = exports.GetStudyReportResponse = exports.StudyReportListExportFormat = void 0;
var StudyReportListExportFormat;
(function (StudyReportListExportFormat) {
    StudyReportListExportFormat["Excel"] = "XLS";
    StudyReportListExportFormat["CSV"] = "CSV";
})(StudyReportListExportFormat = exports.StudyReportListExportFormat || (exports.StudyReportListExportFormat = {}));
class GetStudyReportResponse {
}
exports.GetStudyReportResponse = GetStudyReportResponse;
class DownloadStudyReportResponse {
}
exports.DownloadStudyReportResponse = DownloadStudyReportResponse;
class GetStudyReportListDownloadUrlResponse {
}
exports.GetStudyReportListDownloadUrlResponse = GetStudyReportListDownloadUrlResponse;
class UpdateStudyReportResponse {
}
exports.UpdateStudyReportResponse = UpdateStudyReportResponse;
//# sourceMappingURL=studyReport.js.map